import React, { useEffect } from 'react'
import BlogPreview from '../../../Blog/BlogPreview'
import { Row, Col, Container } from 'components/Layout'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'
import sLay from 'styles/modules/layout.scss'
import s from '../../../Blog/BlogIndex/BlogIndex.scss'

export default props => {
  useEffect(() => {
    props.getArticles()
  }, [])

  const { articles, horizontal } = props

  return (
    <Container className={cn(s.content, sAnim.comeUp)} paddingTop paddingBottom>
      <Row className={cn(sLay['layout-row'], sLay['layout-wrap'])}>
        {articles.map((article, idx) => (
          <Col
            key={article.fields.slug || idx}
            className={
              horizontal
                ? cn(sLay['flex-100'], s.item)
                : cn(
                    sLay['flex-gt-md-33'],
                    sLay['flex-md-50'],
                    sLay['flex-sm-100'],
                    sLay['flex-xs-100'],
                    s.item
                  )
            }
          >
            <BlogPreview
              article={article}
              horizontal={horizontal}
              location={{ pathname: '/blog' }}
            />
          </Col>
        ))}

        {articles.length === 0 && (
          <div className={sText.descrip2}>
            There are no blog articles matching the given criteria.
          </div>
        )}
      </Row>
    </Container>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BlogArticles/BlogArticles.jsx